import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    becomingAwareThrough: Yup.string().required("Angabe ist erforderlich"),
    recruitingBy: checkText(settings),
});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>Wie sind Sie auf uns aufmerksam geworden?*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row >
            {values.becomingAwareThrough === "Mitarbeiterempfehlung" && <Form.Group  className="mb-3" controlId="formRecruitingBy">
                <Form.Label>Geworben durch (Name, Vorname)</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Geworben durch (Name, Vorname)"
                    type="text"
                    name="recruitingBy"
                    value={values.recruitingBy}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.recruitingBy && !errors.recruitingBy}
                    isInvalid={touched.recruitingBy && errors.recruitingBy}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.recruitingBy}
                </Form.Control.Feedback>
            </Form.Group>}

        </>
    );
};